/** An empty collection is an invitation to act, not a blank page. */
export function EmptyState() {
  return (
    <div className="state">
      <h2>No plants yet</h2>
      <p>
        The API is connected and the collection is empty. Plants appear here once they are added,
        grouped by where they live.
      </p>
    </div>
  );
}

/** Says what went wrong and what to do about it, in the app's own voice. */
export function ErrorState({ message }: { message: string }) {
  return (
    <div className="state">
      <h2>Can't reach the API</h2>
      <p>{message}</p>
      <p>
        Check the service is running with <code>make up</code>, then reload.
      </p>
    </div>
  );
}

export function LoadingState() {
  return (
    <div className="state">
      <p>Reading the collection…</p>
    </div>
  );
}
